import * as Sentry from '@sentry/react'

/*
  Error reporting to our self-hosted GlitchTip. No-op unless VITE_SENTRY_DSN is
  set at build time, so dev and any DSN-less build stay silent. DSN is a public
  client ingestion key by design (same model as Sentry).
*/
export function initErrorReporting(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return
  Sentry.init({
    dsn,
    // One shared image serves prod AND staging, so the environment can't be
    // baked at build time — derive it from where the bundle is running.
    environment: location.hostname.includes('.staging.') ? 'staging' : 'production',
    release: (import.meta.env.VITE_RELEASE as string) || undefined,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    beforeSend(event) {
      if (location.hostname === 'localhost') return null
      return event
    },
  })
}

export const captureException = (e: unknown) => Sentry.captureException(e)
